/**
 * VideoJS player orchestrator — composes hooks + pure player.
 * @module components/manage/VideoJS/Body
 */

import React, { useState } from 'react';
import { Message } from 'semantic-ui-react';
import cx from 'classnames';

import VideoJS from './VideoJS';
import { useSubtitleTracks } from './useSubtitleTracks';
import { useStoryboards } from './useStoryboards';

const Body = (props) => {
  const {
    data,
    keyValue,
    onError,
    onXhrResponse,
    setPlayerCallback,
    startTime,
    parentContent,
    parentUid,
    parentItems,
    titleBar,
  } = props;
  const [playerError, setPlayerError] = useState(null);

  const subtitleItems = data.options?.subtitles;
  const { tracks: subtitleTracks } = useSubtitleTracks(subtitleItems);
  const { storyboards } = useStoryboards(parentUid, parentItems);

  const sources = data.options?.sources;
  const watermark = data.options?.watermark;
  const options = {
    fluid: true,
    aspectRatio: '16:9',
    poster:
      data.options?.poster || parentContent?.image?.scales?.huge?.download,
    controls: data.options?.controls,
    playbackRates: data.options?.playbackRates,
    audioOnlyMode: data.options?.audioOnlyMode,
    autoplay: data.options?.autoplay,
    loop: data.options?.loop,
    muted: data.options?.muted,
  };

  return (
    <>
      {!playerError ? (
        <div
          className={cx('video-inner', {
            'full-width': data.align === 'full',
          })}
        >
          <div>
            <VideoJS
              key={keyValue}
              selected={props.selected}
              sources={sources}
              subtitleTracks={subtitleTracks}
              storyboards={storyboards}
              watermark={watermark}
              titleBar={titleBar}
              options={options}
              onReady={(player) => {
                if (setPlayerCallback) setPlayerCallback(player);
                if (startTime != null) player.currentTime(startTime);
              }}
              onError={(player) => {
                setPlayerError(player.error());
                if (onError) onError(player.error());
              }}
              onXhrResponse={onXhrResponse}
            />
          </div>
        </div>
      ) : (
        <div className="invalidVideoFormat">
          <Message>
            <center>{playerError.message}</center>
          </Message>
        </div>
      )}
    </>
  );
};

export default Body;
